import { IIndexable } from '../model/IIndexable';
import { Banner } from '@bpba/modules-components';
import { RubroData } from '../model/RubroData';
import { URL_PATH_CDN } from '../constants/urls';

export function bannersMapping(item: IIndexable) {
  const banner = Banner.fromJsonObject(item);
  banner.enlace = RubroData.getLink(item?.rubroId);
  banner.rutaImagen = `${URL_PATH_CDN}${item.rutaImagen}`;

  return banner;
}
